// import React from "react";
// import {
//   Users,
//   CheckCircle,
//   ArrowRight,
//   Clock,
//   TrendingUp,
//   Award,
//   BarChart3,
// } from "lucide-react";

// const fadeInUp = {
//   initial: { opacity: 0, y: 20 },
//   animate: { opacity: 1, y: 0 },
//   transition: { duration: 0.5 },
// };

// export default function HRMPage() {
//   const features = [
//     {
//       icon: Users,
//       title: "Employee Management",
//       description:
//         "Complete employee records, documents, and skills tracking in one place",
//     },
//     {
//       icon: Clock,
//       title: "Attendance Tracking",
//       description:
//         "Real-time attendance, biometric integration, and automated reports",
//     },
//     {
//       icon: BarChart3,
//       title: "Payroll Management",
//       description:
//         "Automated salary processing, deductions, and compliance handling",
//     },
//     {
//       icon: Award,
//       title: "Performance Reviews",
//       description:
//         "360-degree feedback, goal tracking, and appraisals management",
//     },
//     {
//       icon: Clock,
//       title: "Leave Management",
//       description:
//         "Self-service leave requests with automated approval workflows",
//     },
//     {
//       icon: TrendingUp,
//       title: "Recruitment Tools",
//       description: "Job postings, applicant tracking, and interview scheduling",
//     },
//   ];

//   const modules = [
//     {
//       name: "Core HR",
//       description: "Employee data, organizational structure, policies",
//     },
//     {
//       name: "Recruitment",
//       description: "Job postings, CV screening, interviews, offers",
//     },
//     {
//       name: "Onboarding",
//       description: "New hire workflows, training assignments, checklists",
//     },
//     {
//       name: "Learning & Development",
//       description: "Training programs, skill development, certifications",
//     },
//     {
//       name: "Exit Management",
//       description: "Offboarding process, knowledge transfer, alumni tracking",
//     },
//     {
//       name: "Analytics & Reports",
//       description: "HR metrics, dashboards, workforce insights",
//     },
//   ];

//   const benefits = [
//     "Reduce HR administrative work by 50%",
//     "Improve employee satisfaction and retention",
//     "Ensure payroll compliance and accuracy",
//     "Better workforce planning and analytics",
//     "Faster recruitment and onboarding processes",
//     "Enhanced data security and privacy compliance",
//   ];

//   const hrmProcess = [
//     {
//       step: "Recruitment",
//       description: "Post jobs, screen CVs, conduct interviews",
//     },
//     {
//       step: "Onboarding",
//       description: "Automated workflows for new employees",
//     },
//     {
//       step: "Development",
//       description: "Training, skill development, career planning",
//     },
//     { step: "Performance", description: "Goal setting, reviews, feedback" },
//     { step: "Compensation", description: "Payroll, benefits, incentives" },
//   ];

//   return (
//     <main className="bg-white">
//       {/* Hero */}
//       {/* HERO (ERP STYLE) */}
//       <section className="relative py-24 sm:py-32 bg-gradient-to-br from-slate-900 via-indigo-900 to-slate-900 text-white">
//         {/* Overlay */}
//         <div className="absolute inset-0 bg-gradient-to-r from-indigo-900/90 to-slate-900/90" />

//         <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <div className="inline-flex items-center gap-2 bg-indigo-500/20 px-4 py-2 rounded-full mb-6 border border-indigo-400/30">
//             <Users size={18} />
//             <span className="text-sm font-medium">
//               Human Resource Management
//             </span>
//           </div>

//           <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-4 tracking-tight">
//             HRM
//           </h1>

//           <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto mb-8">
//             Manage employees, payroll, attendance, and performance in one
//             unified platform.
//           </p>

//           <div className="flex flex-col sm:flex-row gap-4 justify-center">
//             <a
//               href="#contact"
//               className="inline-flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-3 rounded-lg font-semibold transition"
//             >
//               Request Demo <ArrowRight size={20} />
//             </a>

//             <a
//               href="#products"
//               className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white px-8 py-3 rounded-lg font-semibold transition"
//             >
//               View Products
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Overview */}
//       <section className="py-20 sm:py-32 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div>
//             <h2
//               className="text-3xl font-bold mb-6"
//               style={{ color: "#0f172a" }}
//             >
//               Empower Your People Strategy
//             </h2>
//             <p className="text-lg max-w-3xl mb-8" style={{ color: "#64748b" }}>
//               Our HRM system helps you manage every aspect of the employee
//               lifecycle, from recruitment to retirement. Automate HR processes,
//               engage employees, and make data-driven decisions about your
//               workforce.
//             </p>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
//               <div
//                 className="rounded-lg p-6 border"
//                 style={{
//                   backgroundColor: "rgba(30, 27, 75, 0.05)",
//                   borderColor: "rgba(30, 27, 75, 0.1)",
//                 }}
//               >
//                 <h3
//                   className="text-2xl font-bold mb-2"
//                   style={{ color: "#1e1b4b" }}
//                 >
//                   Self-Service
//                 </h3>
//                 <p style={{ color: "#64748b" }}>
//                   Employees manage their own documents, leaves, and requests
//                 </p>
//               </div>
//               <div
//                 className="rounded-lg p-6 border"
//                 style={{
//                   backgroundColor: "rgba(30, 27, 75, 0.05)",
//                   borderColor: "rgba(30, 27, 75, 0.1)",
//                 }}
//               >
//                 <h3
//                   className="text-2xl font-bold mb-2"
//                   style={{ color: "#1e1b4b" }}
//                 >
//                   Compliance
//                 </h3>
//                 <p style={{ color: "#64748b" }}>
//                   Stay compliant with labor laws and regulations
//                 </p>
//               </div>
//               <div
//                 className="rounded-lg p-6 border"
//                 style={{
//                   backgroundColor: "rgba(30, 27, 75, 0.05)",
//                   borderColor: "rgba(30, 27, 75, 0.1)",
//                 }}
//               >
//                 <h3
//                   className="text-2xl font-bold mb-2"
//                   style={{ color: "#1e1b4b" }}
//                 >
//                   Analytics
//                 </h3>
//                 <p style={{ color: "#64748b" }}>
//                   Data-driven HR decisions and workforce insights
//                 </p>
//               </div>
//             </div>
//             <div className="bg-gradient-to-r from-indigo-50 to-blue-50 rounded-lg shadow-md p-12 flex items-center justify-center">
//               <Users size={80} className="text-indigo-300" />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Features Grid */}
//       <section
//         className="py-20 sm:py-32"
//         style={{ backgroundColor: "#f8fafc" }}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="mb-12">
//             <h2
//               className="text-3xl font-bold mb-6"
//               style={{ color: "#0f172a" }}
//             >
//               Core Features
//             </h2>
//             <p className="text-lg max-w-3xl" style={{ color: "#64748b" }}>
//               Comprehensive HR tools designed to streamline every HR function
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {features.map((feature, index) => {
//               const Icon = feature.icon;
//               return (
//                 <div
//                   key={index}
//                   className="bg-white rounded-lg p-8 border hover:shadow-lg transition-all"
//                   style={{ borderColor: "#e2e8f0" }}
//                 >
//                   <div
//                     className="w-14 h-14 rounded-lg flex items-center justify-center mb-4"
//                     style={{ backgroundColor: "rgba(30, 27, 75, 0.1)" }}
//                   >
//                     <Icon size={28} style={{ color: "#1e1b4b" }} />
//                   </div>
//                   <h3
//                     className="text-xl font-bold mb-3"
//                     style={{ color: "#0f172a" }}
//                   >
//                     {feature.title}
//                   </h3>
//                   <p style={{ color: "#64748b" }}>{feature.description}</p>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* Modules */}
//       <section className="py-20 sm:py-32 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="mb-12">
//             <h2
//               className="text-3xl font-bold mb-6"
//               style={{ color: "#0f172a" }}
//             >
//               Key Modules
//             </h2>
//             <p className="text-lg max-w-3xl" style={{ color: "#64748b" }}>
//               Integrated modules for managing every HR function seamlessly
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {modules.map((module, index) => (
//               <div
//                 key={index}
//                 className="rounded-lg p-6 border hover:border-indigo-900 transition-all"
//                 style={{
//                   background:
//                     "linear-gradient(to bottom right, rgba(30, 27, 75, 0.05), rgba(67, 56, 202, 0.05))",
//                   borderColor: "rgba(30, 27, 75, 0.1)",
//                 }}
//               >
//                 <h3
//                   className="text-lg font-bold mb-2"
//                   style={{ color: "#0f172a" }}
//                 >
//                   {module.name}
//                 </h3>
//                 <p style={{ color: "#64748b" }}>{module.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* HR Lifecycle */}
//       <section
//         className="py-20 sm:py-32"
//         style={{ backgroundColor: "#f8fafc" }}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="mb-12">
//             <h2
//               className="text-3xl font-bold mb-6"
//               style={{ color: "#0f172a" }}
//             >
//               Complete Employee Lifecycle
//             </h2>
//             <p className="text-lg max-w-3xl" style={{ color: "#64748b" }}>
//               Manage every stage of employee journey from recruitment to
//               retirement
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
//             {hrmProcess.map((item, index) => (
//               <div
//                 key={index}
//                 className="bg-white rounded-lg p-6 border text-center"
//                 style={{ borderColor: "#e2e8f0" }}
//               >
//                 <div
//                   className="w-10 h-10 rounded-full flex items-center justify-center font-bold mx-auto mb-4"
//                   style={{ backgroundColor: "#1e1b4b", color: "white" }}
//                 >
//                   {index + 1}
//                 </div>
//                 <h3
//                   className="text-lg font-bold mb-2"
//                   style={{ color: "#0f172a" }}
//                 >
//                   {item.step}
//                 </h3>
//                 <p className="text-sm" style={{ color: "#64748b" }}>
//                   {item.description}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Benefits */}
//       <section className="py-20 sm:py-32 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="mb-12">
//             <h2
//               className="text-3xl font-bold mb-6"
//               style={{ color: "#0f172a" }}
//             >
//               Business Benefits
//             </h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
//             {benefits.map((benefit, index) => (
//               <div
//                 key={index}
//                 className="flex items-start gap-4 rounded-lg p-6 border"
//                 style={{ backgroundColor: "#f8fafc", borderColor: "#e2e8f0" }}
//               >
//                 <CheckCircle
//                   className="flex-shrink-0 mt-1"
//                   size={24}
//                   style={{ color: "#1e1b4b" }}
//                 />
//                 <span className="text-lg" style={{ color: "#0f172a" }}>
//                   {benefit}
//                 </span>
//               </div>
//             ))}
//           </div>
//           <div className="bg-gradient-to-r from-indigo-50 to-blue-50 rounded-lg shadow-md p-12 flex items-center justify-center">
//             <TrendingUp size={80} className="text-indigo-300" />
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section
//         style={{ background: "linear-gradient(to right, #1e1b4b, #4338ca)" }}
//         className="py-20 sm:py-32 text-white"
//       >
//         <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <div>
//             <h2 className="text-3xl sm:text-4xl font-bold mb-4">
//               Build a Great Workplace Culture
//             </h2>
//             <p className="text-lg opacity-90 mb-8">
//               Let our HRM system help you attract, develop, and retain top
//               talent
//             </p>
//             <div className="flex flex-col sm:flex-row gap-4 justify-center">
//               <a
//                 href="#contact"
//                 className="inline-flex items-center justify-center gap-2 bg-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
//                 style={{ color: "#1e1b4b" }}
//               >
//                 Request Demo <ArrowRight size={20} />
//               </a>
//               <a
//                 href="#products"
//                 className="inline-flex items-center justify-center gap-2 bg-white/20 text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/30 transition-colors"
//               >
//                 View Other Products
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>
//     </main>
//   );
// }

import React from "react";
import {
  Users,
  CheckCircle2,
  ArrowRight,
  Fingerprint,
  CalendarDays,
  CreditCard,
  Briefcase,
  UserPlus,
  ShieldCheck,
  BarChart3,
  Clock,
  HeartPulse,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function HRMPage() {
  const features = [
    {
      icon: UserPlus,
      title: "Automated Onboarding",
      description:
        "Digital documentation and asset allocation for a seamless day-one employee experience.",
    },
    {
      icon: CreditCard,
      title: "Statutory Payroll",
      description:
        "One-click payroll processing with built-in compliance for PF, PT, ESI, and TDS calculations.",
    },
    {
      icon: Clock,
      title: "Attendance & Leaves",
      description:
        "Biometric integration and geo-fenced mobile check-ins with automated leave workflows.",
    },
    {
      icon: HeartPulse,
      title: "Performance Mgmt",
      description:
        "Objective-based tracking with 360-degree feedback loops and digital appraisal cycles.",
    },
    {
      icon: ShieldCheck,
      title: "Employee Self-Service",
      description:
        "Centralized portal for payslip downloads, tax declarations, and internal service requests.",
    },
    {
      icon: BarChart3,
      title: "Workforce Analytics",
      description:
        "Real-time insights into attrition rates, diversity metrics, and department-wise cost analysis.",
    },
  ];

  return (
    <main className="bg-white selection:bg-emerald-100 font-inter">
      {/* ========== HERO SECTION ========== */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#062c26]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&q=80&w=1600')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#062c26] via-[#062c26]/90 to-transparent" />

        <div className="relative max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-2xl text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-[10px] font-bold tracking-[0.2em] uppercase mb-4">
              Human Capital Management
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Agile <span className="text-emerald-500">Workforce</span> Systems.
            </h1>
            <p className="text-base text-slate-400 text-white max-w-lg mb-8 leading-relaxed font-light">
              From recruitment to retirement. A comprehensive HRM ecosystem
              built to simplify payroll, compliance, and employee engagement.
            </p>
            <div className="flex gap-3 flex-wrap">
              <Link
                to="/contact"
                className="bg-emerald-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-emerald-700 transition-all shadow-lg shadow-emerald-900/40 flex items-center gap-2"
              >
                Initiate Free Demo <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ========== CORE VALUE PROPOSITION ========== */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-5 text-left">
              <span className="text-emerald-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-4">
                Strategic HR
              </span>
              <h2 className="text-3xl font-bold text-slate-900 mb-6 tracking-tight leading-tight">
                Focus on people, not <br />
                <span className="text-slate-400">Paperwork.</span>
              </h2>
              <p className="text-slate-600 mb-8 leading-relaxed text-sm">
                Our HRM platform automates the administrative burden of HR
                management, allowing your leadership to focus on building a
                high-performance culture.
              </p>
              <div className="space-y-4">
                {[
                  {
                    t: "Error-Free Payroll",
                    d: "Automated tax compliance tailored for Indian labor laws.",
                  },
                  {
                    t: "Unified Employee Directory",
                    d: "One secure database for all documents and records.",
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="flex gap-4 p-4 rounded-xl bg-slate-50 border border-slate-100"
                  >
                    <CheckCircle2
                      className="text-emerald-600 shrink-0"
                      size={20}
                    />
                    <div className="text-left">
                      <h4 className="text-sm font-bold text-slate-900">
                        {item.t}
                      </h4>
                      <p className="text-xs text-slate-500 mt-1">{item.d}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:col-span-7 relative">
              <div className="absolute -inset-4 bg-emerald-100/30 rounded-[2rem] -z-10 blur-xl" />
              <img
                src="https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&q=80&w=1200"
                alt="HRM Dashboard Overview"
                className="rounded-2xl shadow-2xl border border-slate-100"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ========== OPERATIONAL IMPACT CARDS ========== */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-emerald-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Culture & Compliance
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              The Infronex HR Experience
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 group text-left">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-50 text-emerald-600 mb-6 group-hover:bg-emerald-600 group-hover:text-white transition-all duration-300">
                <Fingerprint size={24} />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-4 tracking-tight group-hover:text-emerald-600 transition-colors">
                Smart Attendance
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed font-light">
                Sync with biometric devices or use geo-fenced mobile logins to
                manage your remote and on-site workforce.
              </p>
            </div>

            <div className="bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 group text-left">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-50 text-emerald-600 mb-6 group-hover:bg-emerald-600 group-hover:text-white transition-all duration-300">
                <CalendarDays size={24} />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-4 tracking-tight group-hover:text-emerald-600 transition-colors">
                Unified Leave Desk
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed font-light">
                Automated leave balance tracking and approval workflows that
                integrate directly with your monthly payroll.
              </p>
            </div>

            <div className="bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 group text-left">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-50 text-emerald-600 mb-6 group-hover:bg-emerald-600 group-hover:text-white transition-all duration-300">
                <ShieldCheck size={24} />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-4 tracking-tight group-hover:text-emerald-600 transition-colors">
                Compliance Lock
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed font-light">
                Stay updated with the latest Indian labor laws. Automatically
                generate PF, ECR, and Form-16 reports.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ========== KEY CAPABILITIES CARDS ========== */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-emerald-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Enterprise Stack
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Technical Domain Capabilities
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div
                key={i}
                className="group bg-white border border-slate-100 p-8 rounded-2xl shadow-sm hover:shadow-md hover:border-emerald-500/30 transition-all duration-300 text-left relative overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-24 h-24 bg-emerald-50/50 rounded-full -mr-12 -mt-12 group-hover:bg-emerald-100 transition-colors" />

                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-50 text-slate-900 mb-6 group-hover:bg-emerald-600 group-hover:text-white transition-all duration-300 shadow-sm relative z-10">
                  <f.icon size={20} />
                </div>

                <h3 className="text-[17px] font-bold text-slate-900 mb-3 tracking-tight group-hover:text-emerald-600 transition-colors relative z-10">
                  {f.title}
                </h3>

                <p className="text-[13px] text-slate-500 leading-relaxed font-normal relative z-10">
                  {f.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== FINAL CTA ========== */}
      <section className="py-24 bg-[#062c26] relative overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full opacity-10 pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[300px] bg-emerald-500 rounded-full blur-[100px]" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-6 tracking-tight">
            Streamline your workforce today.
          </h2>
          <p className="text-slate-400 mb-8 font-light max-w-xl mx-auto leading-relaxed">
            Empower your HR team with a platform that handles the complexity of
            operations so you can focus on your people.
          </p>
          <div className="flex justify-center">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-8 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-50 transition-all shadow-xl"
            >
              Initiate Technical Demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}